import { UserData, AuthStates, UserDataTypes, UserDataAction } from "./types";

export const initialState: UserData = {
  email: "",
  displayName: "",
  initials: "",
  photoUrl: "",
  authState: AuthStates.LOADING,
  mpoeApplicationUrl: "",
  bridgeCommanderLink: "",
  permissions: {
    canViewAccountPlanOverview: false,
    bridgeFull: false,
    canViewBridgePaymentSettings: false,
    canViewBridgeExpandedInformation: false,
    canViewBridgeBasicInformation: false,
    canViewEmployeesDashboard: false,
    canViewHistoryOfAllEmployees: false,
    canUpdateBridgeBasicInformation: false,
  },
};

const userDataReducer = (
  state = initialState,
  { type, payload }: UserDataAction
) => {
  switch (type) {
    case UserDataTypes.AUTH_SET:
      return {
        ...state,
        authState: AuthStates.ALLOWED,
        mpoeApplicationUrl: payload.mpoeApplicationUrl,
        email: payload.email,
        displayName: payload.displayName,
        initials: payload.initials,
        photoUrl: payload.photoUrl,
        bridgeCommanderLink: payload.bridgeCommanderUrl,
        permissions: {
          ...payload.permissions,
        },
      };
    case UserDataTypes.AUTH_LOGOUT:
      return {
        ...state,
        authState: AuthStates.LOADING,
        mpoeApplicationUrl: "",
        email: "",
        displayName: "",
        initials: "",
        photoUrl: "",
      };

    case UserDataTypes.AUTH_ERROR:
      return {
        ...state,
        authState: AuthStates.DENIED,
      };
    case UserDataTypes.SET_SYSTEM_ERROR:
      return {
        ...state,
        authState: AuthStates.DENIED,
      };
    default:
      return state;
  }
};
export default userDataReducer;
